import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { PackingProcessStep } from './packing-process-step';



export class PackingProcess extends BaseEntity {

  id                  : number;
	packingProcessCode  : string;
  name                : string ;
	rank                : number;
  packingProcessSteps : PackingProcessStep[];

  constructor() {
    super();

  }
}

	
